<template>
  <div style="padding-bottom: 100px;">
    <header class="p-2x bg-primary white text-c">
      <h3>{{ roomName }}</h3>
      <div class="mt-1x">
        {{start}}
        <van-tag type="warning" class="mh-1x" round size="large">{{dayNum}}晚</van-tag>
        {{end}}
      </div>
    </header>
    <div class="flex-start box mt-1x">
      <p>预定数量(间)：</p>
      <van-stepper :max="maxRoomNum" @change="roomNumChange"/>
    </div>
    <van-cell-group>
      <van-field
          required
          v-model="nameList[item - 1]"
          :label="`入住顾客${item}`"
          left-icon="user-o"
          placeholder="请输入姓名（1间填写1个人）"
          v-for="item in roomNum" :key="'name' + item"
      />
      <van-field
          required
          v-model="phone_no"
          label="手机号码"
          left-icon="phone-o"
          placeholder="请填写联系电话"
          type="number"
      />
      <div class="flex-start box bd-b">
        <p>单个房间入住人数(人)：</p>
        <van-stepper :max="5" v-model="no_of_guests" @change="peopleChange"/>
      </div>
      <van-field type="textarea" label="备注" placeholder="请输入备注信息"
                 v-model="remark"  maxlength="50"  show-word-limit
      />
    </van-cell-group>
    <!--积分抵扣-->
    <ul class="list mt-1x pd-h" v-if="bonusPay || couponPay">
      <li class="item flex-between"
          @click="showCoupon = true"
          v-if="couponPay"
      >
        <div class="flex-start">
          <p>优惠券</p>
          <div class="ak-tag small primary out-line ml-1x"
               v-if="useCoupons.length"
          >已选{{ useCoupons.length }}张
          </div>
        </div>
        <div class="flex-start">
          <p v-if="couponMoney === 0">{{ usableCoupon.length }}张可用</p>
          <p class="primary" v-else>优惠 ¥{{ couponMoney }}</p>
          <van-icon name="arrow" class="ml-1x"></van-icon>
        </div>
      </li>
      <li class="item flex-between font-s" v-if="profile.bonus_rule && bonusPay">
        <p>共{{ member.bonus }}积分，
          <span v-show="!checked">可用{{ bonus }}积分，抵 ¥{{ bonusMoney }}</span>
          <span v-show="checked">使用{{ useBonus }}积分，抵 ¥{{ useBonusMoney }}</span>
          <span class="primary ml-1x" @click="showPopup" v-show="checked">修改</span>
        </p>
        <van-switch v-model="checked" @change="change"
                    size="18px"
                    :disabled="!bonus"
        />
      </li>
    </ul>
    <!--支付方式-->
    <p class="ph-2x mt-2x">选择支付方式</p>
    <div class="cards flex-between shadow" @click="usePayType(0)">
      <svg t="1591008225210" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3811" width="30" height="30"><path d="M391.413127 642.866409c-60.886486 36.373745-69.584556-20.559073-69.584556-20.559073l-75.910424-192.148263c-29.257143-90.934363 25.303475-41.118147 25.303475-41.118146S317.874903 426.996139 353.457915 450.718147s75.910425 7.116602 75.910425 7.116602l496.580695-248.290347C834.223938 86.980695 683.193822 6.325869 511.604633 6.325869 232.475676 6.325869 5.535135 221.405405 5.535135 486.301158 5.535135 638.912741 80.654826 774.128185 197.683398 861.899614l-21.349807 131.261776s-10.279537 37.955212 25.303475 20.559073c24.512741-11.861004 86.189961-55.351351 122.563706-82.236293 60.095753 22.140541 123.35444 34.001544 187.403861 34.001544 279.128958 0 506.069498-215.079537 506.069498-479.975289 0-76.701158-18.977606-149.448649-52.97915-213.49807-157.355985 102.795367-525.837838 342.387645-573.281854 370.854054z" fill="#24AF41" p-id="3812"></path></svg>
      <span class="flex-1 ml-1x">微信支付</span>
      <van-icon name="checked" size="20" class="primary" v-show="payType === 0" />
      <van-icon name="circle" size="20" class="gray" v-show="payType !== 0" />
    </div>

    <div class="cards flex-between shadow" v-if="memberPay" @click="usePayType(1)">
      <van-icon name="vip-card-o" size="30" class="orange" />
      <div class="flex-1 ml-1x">
        <span>会员卡支付</span>
        <span class="font-s gray">({{member.card_type_name}})</span>
      </div>
      <p class="gray mr-2x font-s">余额：¥{{ member.balance }}</p>
      <van-icon name="checked" size="20" class="primary" v-show="payType === 1" />
      <van-icon name="circle" size="20" class="gray" v-show="payType !== 1" />
    </div>
    <!--底部-->
    <footer class="footer flex-between bd-t">
      <div @click="orderInfoDialog = true" class="flex-start flex-grow">
        <div class="mr-x">合计：¥{{totalSum}}</div>
        <van-icon :name="orderInfoDialog ? 'arrow-up' : 'arrow-down'"></van-icon>
      </div>
      <p class="red flex-shrink mr-2x">实付：¥{{ lastMoney > 0 ? lastMoney : 0 }}</p>
      <van-button type="danger" @click="reserve"
                  :loading="loading" loading-text="预定中..."
      >立即预定</van-button>
    </footer>
    <!-- 订单明细 start -->
    <van-dialog v-model="orderInfoDialog" title="费用明细">
      <section class="box" style="max-height: 70vh; overflow-y: auto">
        <div>
          <p>{{orderInfo.start.date | date}}</p>
          <p >{{orderInfo.room.spec.NAME}}</p>
          <p class="text-r">{{roomNum}} x ¥{{orderInfo.start.custom.price}}</p>
        </div>
        <div v-for="(item,index) in orderInfo.range" :key="index">
          <p>{{item.date | date}}</p>
          <p>{{orderInfo.room.spec.NAME}}</p>
          <p class="text-r">{{roomNum}} x ¥{{item.data.custom.price}}</p>
        </div>
        <div class="bd-t mt-2x pt-2x">
          <p>总价</p>
          <p class="text-r orange">¥{{totalSum}}</p>
        </div>
      </section>
    </van-dialog>
    <!--优惠券选择-->
    <coupon-list :usable="usableCoupon" :disable="disableCoupon" v-model="showCoupon" @selected="selectCoupon"></coupon-list>
<!--    <van-popup v-model="showCoupon" round-->
<!--               position="bottom" style="height: 80%"-->
<!--    >-->
<!--      <div class="bd-b action-title">-->
<!--        <div class="flex-between">-->
<!--          <h4>可用优惠券</h4>-->
<!--          <van-icon name="close" size="18" @click="showCoupon = false" />-->
<!--        </div>-->
<!--        <p class="font-s mt-1x">已选中优惠券{{ useCoupons.length }}张，共抵扣 <span class="red">¥{{ couponMoney }}</span></p>-->
<!--      </div>-->
<!--      <ul>-->
<!--        <li v-for="temp in couponList" :Key="temp.id"-->
<!--            class="flex-between coupon" @click="selectCoupon(temp)"-->
<!--        >-->
<!--          <div class="ph-2x flex-grow">-->
<!--            <h4>{{ temp.product.name }}</h4>-->
<!--            <p class="font-s mt-x" v-if="temp.product.card_least_cost"> 购满{{ temp.product.card_least_cost }}元可用 </p>-->
<!--            <p class="font-s mt-x" v-else> 无门槛 </p>-->
<!--            <p class="font-s mt-x">每日使用时段: {{ temp.product.time_start }} ~ {{ temp.product.time_start }}</p>-->
<!--            <p class="font-s mt-x"-->
<!--               v-if="temp.product.card_date_type === 'RANGE'"-->
<!--            >{{ temp.product.card_start_date | date }}至{{ temp.product.card_end_date | date }}有效-->
<!--            </p>-->
<!--            <p class="font-s mt-x" v-else>-->
<!--              <span v-if="temp.product.card_fixed_begin_term">领取{{ temp.product.card_fixed_begin_term }}天后生效,</span>-->
<!--              <span v-else>领取后立即生效,</span>-->
<!--              <span>生效后{{ temp.product.card_fixed_term }}天内使用</span>-->
<!--            </p>-->
<!--          </div>-->
<!--          <div class="action pv-1x text-c" :style="{background: temp.product.card_color}">-->
<!--            <div class="flex-center mt-3x white">-->
<!--              <p class="font-l mt-x">¥</p>-->
<!--              <h1 class="mh-x">{{ temp.product.unit_price }}</h1>-->
<!--            </div>-->
<!--            <ul class="gap">-->
<!--              <li class="circle" v-for="item in 11" :key="item"></li>-->
<!--            </ul>-->

<!--            <div class="select white">-->
<!--              <van-icon name="circle" size="24" v-show="!temp.selected" />-->
<!--              <van-icon name="checked" size="24" v-show="temp.selected" />-->
<!--            </div>-->
<!--          </div>-->
<!--        </li>-->
<!--      </ul>-->

<!--      <p class="empty pb-2x" v-if="couponList.length === 0">———— 没有可用的优惠券 ————</p>-->
<!--    </van-popup>-->
    <!--修改积分-->
    <van-popup
        v-model="showBonus"
        round
        closeable
        position="bottom"
    >
      <h4 class="pv-2x text-c">自定义抵扣金额</h4>
      <p class="ph-2x">账户积分：<b>{{ member.bonus }}</b></p>
      <div>
        <div class="flex-between">
          <van-field
              style="padding: 10px 16px 0 16px;"
              required
              v-model="cumMoney"
              label="需抵扣金额"
              placeholder="请填写抵扣金额"
              max
              @input="clearRefundNumber"
              type="number"
          />
          <p class="flex-shrink pr-2x">使用积分：{{ cumBonus }}</p>
        </div>
        <p class="gray font-s ph-2x">最大可抵扣的金额：￥{{ bonusMoneyCopy }}</p>
      </div>
      <div class="pv-2x">
        <van-button :disabled="!cumBonus" type="info" block @click="bonusPopClick">确定</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import {getStore, removeStore} from '../config/utils'
  // import { newResv, getPaySign, ensurePayment } from '../api/getData'
  import CouponList from '../components/SelectCoupon'

  export default {
  name: 'Order',
  components: { CouponList },
  data () {
    return {
      loading: false,
      activeNames: [],
      activeNames2: [],
      nameList: [''], // 入住姓名列表
      phone_no: '', // 联系号码
      no_of_guests: 1, // 单间入住人数
      remark: '', // 备注
      roomName:'', // 房间名称
      start:'', // 入住日期
      end:'',  //  离店日期
      orderInfo: '', // 明细
      dayNum:'', // 入住几晚
      spec:'', // 规格描述
      maxRoomNum: 1, // 最大房间数量
      roomNum: 1 , // 预定的房间数量
      price: 0, // 入住几晚，1间房的价格
      totalSum: 0, //订单总金额
      infoDialog: false, // 酒店详情dialog
      orderInfoDialog: false, // 订单详情dialog
      timer: '', // 定时器名称
      confirm_number: '', // 付款订单的流水号

      payCodes: [], // 付款代码列表
      payType: 0, // 支付方式
      member: {}, // 会员信息
      profile: {}, // 会员模板
      showCoupon: false,
      usableCoupon: [], // 可用优惠券
      disableCoupon: [], // 不可用优惠券
      checked: false,
      couponMoney: 0,
      useCoupons: [],
      bonus: 0, // 可用积分，
      bonusMoney: 0, // 积分抵可扣金额//
      bonusCopy: 0, // 最大可用积分储存，
      bonusMoneyCopy: 0, // 最大积分抵可扣金额储存//
      cumMoney: '',
      cumBonus: 0,
      // bonusList: [], // 修改的选择积分列表
      useBonus: 0, // 使用积分
      useBonusMoney: 0, // 积分抵扣金额//
      showBonus: false,
      deductionNum: 0, // 抵扣单元
    }
  },
  created(){
    this.getOrder()
    this.loadPayment()
    this.loadMember()
  },
  computed: {
    // 抵扣后的最终支付金额
    lastMoney() {
      return Math.round((this.totalSum - this.couponMoney - this.useBonusMoney) * 100) / 100
    },
    memberPay() { // 是否会员付款
      return this.payCodes.find(item => item.payment_code === 'LZPAY') && this.member.id
    },
    bonusPay() { // 是否积分付款
      return this.payCodes.find(item => item.payment_code === 'BONUS') && this.member.id
    },
    couponPay() { // 是否优惠券付款
      return this.payCodes.find(item => item.payment_code === 'CARD') && this.member.id
    }
  },
  watch: {
    // 房间数量改变时
    'roomNum'(num) {
       this.totalSum = Math.round(this.price * num * 100) / 100  // 总金额
      this.checked = false
      this.useBonusMoney = 0
      this.useBonus = 0
       this.deductionNumFun() // 计算最大使用积分最优化
    }
  },
  methods: {
    // 获取订单信息
    getOrder() {
      const orderInfo = JSON.parse(getStore('orderInfo'))
      this.orderInfo = orderInfo
      // console.log('orderInfo:',this.orderInfo)
      this.roomName = orderInfo.room.name
      this.start = orderInfo.start.date
      this.end = orderInfo.end.date
      this.spec = orderInfo.room.spec.NAME
      this.maxRoomNum = orderInfo.start.custom.maxRoomNum
      if(this.maxRoomNum < orderInfo.end.custom.maxRoomNum){
        this.maxRoomNum = orderInfo.end.custom.maxRoomNum
        // 一次最大只能预定9间房
        if ( orderInfo.end.custom.maxRoomNum > 9) { this.maxRoomNum = 9 }
      }
      // 入住超过一晚
      if (orderInfo.range.length > 0) {
        this.dayNum = orderInfo.range.length + 1
        // 对比，取出最小的放房数，设置为最大可以选择的预定房间数
        orderInfo.range.forEach(item => {
          if (this.maxRoomNum < item.data.custom.maxRoomNum) {
            this.maxRoomNum = item.data.custom.maxRoomNum
          }
        })
        let rangeTotal = 0
        orderInfo.range.forEach(item => {
          rangeTotal += item.data.custom.price
        })

        // this.price = (orderrInfo.room.spec.PRICE) * (orderInfo.range.length + 1)  // 总金额
        this.price = Math.round((orderInfo.start.custom.price + rangeTotal) * 100) / 100 // 总金额
        this.totalSum = this.price  // 总金额
      } else {
        // 入住一晚
        this.dayNum =  1
        this.totalSum = orderInfo.start.custom.price  // 总金额
        this.price = orderInfo.start.custom.price
        if(this.maxRoomNum < orderInfo.end.custom.maxRoomNum){ this.maxRoomNum = orderInfo.end.custom.maxRoomNum }
      }

    },
    // 加载付款方式
    loadPayment() {
      this.$fetch({
        url: '/api/payment/ListPayment'
      })
        .then(res => {
          this.payCodes = res
        })

    },
    // 加载会员信息
    loadMember() {
      this.$fetch({
        url: '/api/member_card/ListOne',
        params: {
          member_card_id: JSON.parse(localStorage.getItem('setUserInfo')).openid,
          search_type: 1
        }
      })
      .then(res => {
        this.member = res.card_member || {}
        this.profile = res.card_profile || {}
        const bonusRule = this.profile.bonus_rule
        if (bonusRule) { // 如果使用积分优惠抵扣
          if (this.member.bonus > bonusRule.cost_bonus_unit) {
            let maxBonus = 0
            // 最大抵扣积分上限
            if (this.member.bonus > bonusRule.max_reduce_bonus) {
              maxBonus = bonusRule.max_reduce_bonus
            } else {
              maxBonus = this.member.bonus
            }
            // 抵扣单元
            this.deductionNum = Math.floor(maxBonus / bonusRule.cost_bonus_unit)
            if (isNaN(this.deductionNum)) this.deductionNum = 0
            this.bonusCopy = bonusRule.cost_bonus_unit * this.deductionNum // 可用积分
            this.bonusMoneyCopy = bonusRule.reduce_money * this.deductionNum
            this.bonus = bonusRule.cost_bonus_unit * this.deductionNum // 可用积分
            this.bonusMoney = bonusRule.reduce_money * this.deductionNum
            this.deductionNumFun()
            // 积分列表
            // 积分列表
            // for (let i = 1; i <= n; i++) {
            //   this.bonusList.push({
            //     selected: false,
            //     bonus: i * bonusRule.cost_bonus_unit,
            //     money: bonusRule.reduce_money * i
            //   })
            // }
            // this.bonusMoney = bonusRule.reduce_money * n

            // this.bonusMoney = bonusRule.reduce_money * n
          }
        }
        this.loadCoupon()
      })
    },
    deductionNumFun() {
      const bonusRule = this.profile.bonus_rule
      if (bonusRule) {
        let isTrue = true
        for (let i = 1; i <= this.deductionNum; i++) {
          if (bonusRule.reduce_money * i >= this.totalSum && isTrue) {
            this.bonus = i * bonusRule.cost_bonus_unit
            this.bonusMoney = bonusRule.reduce_money * i
            isTrue = false
            break
            // this.bonusList.push({ // 抵扣列表暂时隐藏，待删除
            //   selected: true,
            //   bonus: i * bonusRule.cost_bonus_unit,
            //   money: bonusRule.reduce_money * i
            // })
          }
          else {
            if (i === this.deductionNum && isTrue) {
              this.bonus = i * bonusRule.cost_bonus_unit
              this.bonusMoney = bonusRule.reduce_money * i
              // isTrue = false
              // this.bonusList.push({
              //   selected: true,
              //   bonus: i * bonusRule.cost_bonus_unit,
              //   money: bonusRule.reduce_money * i
              // })
            }
          }
        }
      }
    },
    // 金额修改处理只允许最多两位小数
    clearRefundNumber() {
      this.cumMoney =  this.cumMoney.match(/^\d*(\.?\d{0,2})/g)[0] || ''
      if (this.cumMoney !== '' && !isNaN(this.cumMoney)) {
        if (Number(this.cumMoney) > this.bonusMoneyCopy) {
          this.cumMoney = this.bonusMoneyCopy
        }
        let bonusRule = this.profile.bonus_rule
        let Num = Math.ceil(Number(this.cumMoney) / bonusRule.reduce_money)
        this.cumBonus = Num * bonusRule.cost_bonus_unit
      }
      else {
        this.cumMoney = ''
        this.cumBonus = 0
      }
    },
    // 自定义抵扣金额确认
    bonusPopClick() {
      this.useBonusMoney = Number(this.cumMoney)
      this.useBonus = this.cumBonus
      this.showBonus = false
    },
    showPopup() {
      this.showBonus = true
    },
    // 加载优惠券列表
    loadCoupon() {
      this.$fetch({
        url: '/api/CardCoupon/QueryByMemberID',
        params: {
          member_id: this.member.id,
          status: 0
        }
      })
        .then(res => {
          res.forEach(item => {
            item.selected = false
            // 可用条件：会员标签与卡券标签有交集 且 核销类型是2 且 包含该房型id 且 符合满多少
            let hasLabel = true
            // 如果设置了标签
            if (item.product.card_member_labels && item.product.card_member_labels.length) {
              if (!this.member.labels) hasLabel = false
                let labels = item.product.card_member_labels.filter(temp => this.member.labels.includes(temp))
                if (labels.length === 0) hasLabel = false
            }
            let usable = hasLabel && item.product.card_off_types.includes(2) && item.product.card_prods_list && item.product.card_prods_list.includes(this.orderInfo.room.spec.ID) && (item.product.card_least_cost === 0 || this.totalSum >= item.product.card_least_cost)
            if(usable) this.usableCoupon.push(item)
            else this.disableCoupon.push(item)
          })
          // 过滤出核销类型为2且符合卡券适用商品且符合满多少可用的卡券
          // this.couponList = res.filter(item => {
          //   item.selected = false // 设置选中属性
          //   // 返回核销类型是2 且 包含该房型id 且 符合满多少
          //   return item.product.card_off_types.includes(2) && item.product.card_prods_list && item.product.card_prods_list.includes(this.orderInfo.room.spec.ID) && (item.product.card_least_cost === 0 || this.totalSum >= item.product.card_least_cost)
          // })
        })
    },
    // 选择优惠券
    selectCoupon(temp) {
      this.couponMoney = 0
      this.useCoupons = []
      this.usableCoupon.forEach(item => {
        if (item.id === temp.id) {
          item.selected = !item.selected
          if (item.selected) {
            this.couponMoney += item.product.unit_price
            this.useCoupons.push(item)
          }
        }
        else {
          item.selected = false
        }
      })
    },
    // 选择积分抵扣
    change(val) {
      if (val) {
        this.useBonusMoney = this.bonusMoney
        this.useBonus = this.bonus
        // 选中最大抵扣积分
        // this.bonusList.forEach(temp => {
        //   temp.selected = false
        // })
        // this.bonusList[this.bonusList.length -1].selected = true
      }
      else {
        this.useBonusMoney = 0
        this.useBonus = 0
        this.cumBonus = 0
        this.cumMoney = ''
      }
    },
    // 选择修改积分
    // selectBonus(item) {
    //   this.bonusList.forEach(temp => {
    //     temp.selected = false
    //   })
    //   item.selected = true
    //   this.useBonus = item.bonus
    //   this.useBonusMoney = item.money
    // },
    // 选择付款方式
    usePayType(type) {
      this.payType = type
      if (type === 1 && this.member.balance < this.price) {
        if (this.member.balance < this.lastMoney) {
          this.payType = 0
          // this.payMoney = ''
          this.$toast('会员卡余额不足')
        }
      }
    },
    // 立即预定
    reserve() {
      let continues = false
      for (let val of this.nameList) {
        if (!val) {
          continues = true
          break
        }
      }
      if (continues) {
        this.$toast('请完善入住顾客信息！')
        return
      }
      if (/^1[3456789]\d{9}$/.test(this.phone_no)) this.check()
      else this.$toast('请填写正确的手机号！')
    },
    // 预下单 检查下单是否会报错，防止钱付了单没下成
    check() {
      const arr = []
      // 应付金额大于0
      if(this.lastMoney > 0) {
        if (this.payType === 0) {
          arr.push({
            payment_code: 'WXPAY',
            amount: this.lastMoney,
          })
        }
        else {
          arr.push({
            payment_code: 'LZPAY',
            amount: this.lastMoney,
          })
        }
      }
      if (this.couponMoney > 0) arr.push({
        payment_code: 'CARD',
        amount: this.couponMoney,
        coupon_code: this.useCoupons[0].coupon_code,
      })
      if (this.useBonusMoney > 0) arr.push({
        payment_code: 'BONUS',
        amount: this.useBonusMoney,
      })
      const orderInfo = JSON.parse(getStore('orderInfo'))
      const start = orderInfo.start.date.split('-').reverse().join('/')
      const end = orderInfo.end.date.split('-').reverse().join('/')
      let notes = `A:${start} D:${end} RT:${orderInfo.room.room_type} ${this.roomNum}间`
      if (this.lastMoney > 0) {
        notes += this.payType === 0 ? ` 付款:微信¥${this.lastMoney}` : ` 付款:会员储蓄卡¥${this.lastMoney}`
      }
      if (this.couponMoney) notes += ` 付款:卡券¥${this.couponMoney}`
      if (this.useBonusMoney) notes += ` 付款:积分抵扣¥${this.useBonusMoney}`
      notes += ` 用户备注:${this.remark}`
      const data = {
        arrival_time: '12:00', // 入住时间
        arrival_date: start,
        depart_time: '12:00',
        depart_date: end, // 离店时间
        room_type_id: orderInfo.room.room_type, // 房价代码
        no_of_rooms: this.roomNum, // 预定房间数
        no_of_guests: this.no_of_guests, //一个房间住几个人
        name: this.nameList.join(','), // 客户姓名
        phone_no: this.phone_no, // 联系号码
        // weichat_id: '', //
        // email: '', //
        deposit_amt: this.totalSum, // 总金额、定金
        deposit: arr, // 多种付款组合
        notes, // 备注
        rate_code_id: orderInfo.room.spec.ID, //
        rate: orderInfo.start.custom.price, // 第一天入住的房间价格
        email: '',
        org_no: '', // 调用端的唯一标识 如果发送重复数据，按org_no查询时只会返回一条
        ar_id: this.member.id || '',
        share_id: sessionStorage.getItem('shareId') || 0,
      }
      this.loading = true
      this.$fetch({
        url: '/api/Reservation/NewResv_v2',
        method: 'post',
        params: { is_for_check: true }, // 不生成实际订单
        data: data
      })
        .then(() => {
          if (this.lastMoney <= 0 || this.payType === 1) {
            this.handleNewResv()
          }
          else if(this.payType === 0) {
            // 首先付款拉起微信支付，要后台业务系统确定付款成功
            this.wxPlay()
          }
        })
        .catch(() => {
          // 返回status状态定义
          // 0 Ok
          // 1 日期格式错误
          // 105 到店离店日期错误
          // 106 单次预定不能超过9间房
          // 107 房间人数不能超过9人
          // 108 日期段没有足够可用房数
          // 109 酒店系统没有设置网上预订的定金代码
          // 110 应收id没有找到或者被禁用
          // 111 应收挂账代码没有设置 联系酒店设置挂账代码
          // 112 应收挂账限额不够
          // Confirm_number : 预定成功后返回的唯一标识号，用于查询.
          this.loading = false
          this.$toast.fail('订单异常')
        })
    },
    // 预定房间后台下单接口
    handleNewResv(voucher_no) {
      const arr = []
      // 应付金额大于0
      if(this.lastMoney > 0) {
        if (this.payType === 0) {
          arr.push({
            payment_code: 'WXPAY',
            amount: this.lastMoney,
          })
        }
        else {
          arr.push({
            payment_code: 'LZPAY',
            amount: this.lastMoney,
          })
        }
      }
      if (this.couponMoney > 0) arr.push({
        payment_code: 'CARD',
        amount: this.couponMoney,
        coupon_code: this.useCoupons[0].coupon_code,
      })
      if (this.useBonusMoney > 0) arr.push({
        payment_code: 'BONUS',
        amount: this.useBonusMoney,
      })
      const orderInfo = JSON.parse(getStore('orderInfo'))
      const start = orderInfo.start.date.split('-').reverse().join('/')
      const end = orderInfo.end.date.split('-').reverse().join('/')
      let notes = `A:${start} D:${end} RT:${orderInfo.room.room_type} ${this.roomNum}间`
      if (this.lastMoney > 0) {
        notes += this.payType === 0 ? ` 付款:微信¥${this.lastMoney}` : ` 付款:会员储蓄卡¥${this.lastMoney}`
      }
      if (this.couponMoney) notes += ` 付款:卡券¥${this.couponMoney}`
      if (this.useBonusMoney) notes += ` 付款:积分抵扣¥${this.useBonusMoney}`
      if (voucher_no) notes += ` 微信支付凭证:${voucher_no}`
      notes += ` 用户备注:${this.remark}`
      const data = {
        arrival_time: '12:00', // 入住时间
        arrival_date: start,
        depart_time: '12:00',
        depart_date: end, // 离店时间
        room_type_id: orderInfo.room.room_type, // 房价代码
        no_of_rooms: this.roomNum, // 预定房间数
        no_of_guests: this.no_of_guests, //一个房间住几个人
        name: this.nameList.join(','), // 客户姓名
        phone_no: this.phone_no, // 联系号码
        // weichat_id: '', //
        // email: '', //
        deposit_amt: this.totalSum, // 总金额、定金
        deposit: arr, // 多种付款组合
        notes, // 备注
        rate_code_id: orderInfo.room.spec.ID, //
        rate: orderInfo.start.custom.price, // 第一天入住的房间价格
        email: '',
        org_no: '', // 调用端的唯一标识 如果发送重复数据，按org_no查询时只会返回一条
        ar_id: this.member.id || '',
        share_id: sessionStorage.getItem('shareId') || 0
      }
      // console.log(data)
      this.loading = true
      this.$fetch({
        url: '/api/Reservation/NewResv_v2',
        method: 'post',
        data: data
      })
        .then(res => {
          const gst_id = res.confirm_number.split(',')[0]
          // 清空缓存
          removeStore('orderInfo')
          this.$toast.success('预定成功')
          setTimeout(() => {
            // alert('付款成功，跳转回订单详情页')
            this.$router.replace({
              path: '/orderinfo',
              query: { gst_id: gst_id, ispay: true }
            })
          }, 200)
        })
        .finally(() => {
          this.loading = false
        })
    },
     // H5调起微信支付
    wxPlay() {
      const isWechat = navigator.userAgent.toLocaleLowerCase().includes('micromessenger')
      // 判断是否是微信浏览器
      if (!isWechat) {
        this.$toast('请使用微信操作')
        return
      }
      const orderInfo = {
        order_id: 0,
        product_name: '酒店预订',
        product_price: this.lastMoney,
        sys_type: 'hotel'
      }
      // alert(JSON.stringify(orderInfo))
      const that = this
      this.$fetch({
        url: '/TenpayV3/GetPaySign',
        method: 'post',
        data: orderInfo
      })
      .then(response => {
        window.clearInterval(that.timer) // 清理定时器
        that.sp_billno = response.sp_billno // 后台提供的支付支付凭证
        window.WeixinJSBridge.invoke(
          'getBrandWCPayRequest', {
            appId: response.appId, // 公众号名称，由商户传入
            timeStamp: response.timeStamp, // 时间戳，自1970年以来的秒数
            nonceStr: response.nonceStr, // 随机串
            package: response.package,
            signType: 'MD5', // 微信签名方式
            paySign: response.paySign, // 微信签名
          },
          function(res) {
            if (res.err_msg !== 'get_brand_wcpay_request:ok' ) {
              window.clearInterval(that.timer) // 清理定时器
            }
          }
        )
        that.timer = setInterval(() => { that.handleEnsurePayment(0, response.sp_billno) }, 1500)
      })
      .catch(() => {
        this.loading = false
      })
    },
    // 业务系统确定付款
    handleEnsurePayment(folio_id, voucher_no) {
      this.$fetch({
        url: '/api/Reservation/EnsurePayment',
        params: {
          folio_id: folio_id,
          voucher_no: voucher_no,
        },
        catch: true
      })
      .then(() => {
        window.clearInterval(this.timer) // 清理定时器
        // 确定付款成功，开单
        this.handleNewResv(voucher_no)
      })
      .finally(() => {
        this.loading = false
      })
    },
    // 房间数量改变
    roomNumChange(val) {
      if(val) this.roomNum = val
      else this.roomNum = 1
      for(let i = 0; i < val; i++) {
        if (!this.nameList[i]) this.$set(this.nameList, i, '')
      }
      this.nameList = this.nameList.slice(0, val)
    },
    // 入住人数改变
    peopleChange(val) {
      if (val) this.no_of_guests = val
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.footer{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding-left: 16px;
  background: white;
  .order-btn{
    padding: 12px 16px;
    color: white;
  }
}
//底部模态框
.modal{
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0;
  background: rgba(0,0,0,0.5);
  overflow: hidden;
  z-index: 10;
  &.show{
    height: 100%;
    .content{
      transform: translateY(0);
    }
  }
  .content{
    transition: transform 0.3s linear;
    transform: translateY(100%);
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    max-height: 80vh;
    background: #fff;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    overflow: scroll;
    .top{
      position: sticky;
      top: 0;
      left: 0;
      padding: 12px 16px;
      z-index: 20;
      background: #fff;
    }
  }
}
</style>
